export const chartSize = {
  fullScreen: "flex flex-col h-full",
  mode1: "flex flex-row items-center justify-center w-full m-7",
  mode2: "flex h-[42rem]",
};
 